(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireee1d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireee1d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("b4vhW", function(module, exports) {

$parcel$export(module.exports, "showSuccess", function () { return $80f856a7a06aa14e$export$d841eba85c078f0b; });
$parcel$export(module.exports, "showError", function () { return $80f856a7a06aa14e$export$3879b24e8245693d; });
// ============================================
// Toast Notifications Module
// ============================================
/**
 * Shows a toast notification.
 * @param {string} message  - Message to display
 * @param {'success'|'error'|'info'|'warning'} type - Toast type
 * @param {number} duration - Duration in milliseconds (default: 3000)
 */ function $80f856a7a06aa14e$export$f6cef6fcf9ca4e17(message) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'info', duration = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 3000;
    var container = document.getElementById('toast-container');
    if (!container) {
        container = document.createElement('div');
        container.id = 'toast-container';
        container.className = 'fb-toast-container';
        container.setAttribute('aria-atomic', 'true');
        document.body.appendChild(container);
    }
    // Update aria-live on every toast so errors always get 'assertive'
    container.setAttribute('aria-live', type === 'error' ? 'assertive' : 'polite');
    var toast = document.createElement('div');
    toast.className = "fb-toast fb-toast-".concat(type);
    toast.setAttribute('role', type === 'error' ? 'alert' : 'status');
    var icons = {
        success: 'fa-circle-check',
        error: 'fa-circle-exclamation',
        info: 'fa-circle-info',
        warning: 'fa-triangle-exclamation'
    };
    var icon = icons[type] || icons.info;
    var iconEl = document.createElement('i');
    iconEl.className = "fa-solid ".concat(icon);
    iconEl.setAttribute('aria-hidden', 'true');
    var textEl = document.createElement('span');
    textEl.textContent = message;
    toast.appendChild(iconEl);
    toast.appendChild(textEl);
    container.appendChild(toast);
    setTimeout(function() {
        return toast.classList.add('show');
    }, 10);
    setTimeout(function() {
        toast.classList.remove('show');
        setTimeout(function() {
            if (container.contains(toast)) container.removeChild(toast);
            if (container.children.length === 0 && document.body.contains(container)) document.body.removeChild(container);
        }, 300);
    }, duration);
}
function $80f856a7a06aa14e$export$d841eba85c078f0b(message) {
    $80f856a7a06aa14e$export$f6cef6fcf9ca4e17(message, 'success');
}
function $80f856a7a06aa14e$export$3879b24e8245693d(message) {
    $80f856a7a06aa14e$export$f6cef6fcf9ca4e17(message, 'error');
}
function $80f856a7a06aa14e$export$3ddc711ac21275cd(message) {
    $80f856a7a06aa14e$export$f6cef6fcf9ca4e17(message, 'info');
}
function $80f856a7a06aa14e$export$da2f4e8190fdb5e1(message) {
    $80f856a7a06aa14e$export$f6cef6fcf9ca4e17(message, 'warning');
}

});

// ============================================
// Solve Page Entry Point (solve.html)
// ============================================

parcelRequire("lylu0");



var $8Y07q = parcelRequire("8Y07q");

var $b4vhW = parcelRequire("b4vhW");
// ============================================
// FizzBuzz Core Algorithm
// ============================================
/**
 * A single FizzBuzz result item.
 * @typedef {{ value: number, label: string }} FizzBuzzItem
 */ /**
 * Validates FizzBuzz inputs.
 *
 * @param {number} fizz  - Fizz divisor
 * @param {number} buzz  - Buzz divisor
 * @param {number} limit - Upper bound (inclusive)
 * @returns {{ valid: boolean, error: string|null }}
 */ function $8adeb145de721250$export$b8d6bda6b8a0445d(fizz, buzz, limit) {
    if (!Number.isInteger(fizz) || fizz < 2 || fizz > 100) return {
        valid: false,
        error: 'Fizz divisor must be an integer between 2 and 100.'
    };
    if (!Number.isInteger(buzz) || buzz < 2 || buzz > 100) return {
        valid: false,
        error: 'Buzz divisor must be an integer between 2 and 100.'
    };
    if (!Number.isInteger(limit) || limit < 1 || limit > 1000) return {
        valid: false,
        error: 'Count To must be an integer between 1 and 1000.'
    };
    return {
        valid: true,
        error: null
    };
}
function $8adeb145de721250$export$ee099e9526bafddb(fizz, buzz, limit) {
    var results = [];
    for(var i = 1; i <= limit; i++){
        var isFizz = i % fizz === 0;
        var isBuzz = i % buzz === 0;
        var label = void 0;
        if (isFizz && isBuzz) label = 'FizzBuzz';
        else if (isFizz) label = 'Fizz';
        else if (isBuzz) label = 'Buzz';
        else label = String(i);
        results.push({
            value: i,
            label: label
        });
    }
    return results;
}
function $8adeb145de721250$export$2cf3d65bc6f74f7d(label) {
    if (label === 'FizzBuzz') return 'fizzbuzz';
    if (label === 'Fizz') return 'fizz';
    if (label === 'Buzz') return 'buzz';
    return 'number';
}
function $8adeb145de721250$export$3512942180f1c205(results) {
    var fizz = 0;
    var buzz = 0;
    var fizzbuzz = 0;
    var numbers = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = results[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var type = $8adeb145de721250$export$2cf3d65bc6f74f7d(item.label);
            if (type === 'fizzbuzz') fizzbuzz++;
            else if (type === 'fizz') fizz++;
            else if (type === 'buzz') buzz++;
            else numbers++;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        fizz: fizz,
        buzz: buzz,
        fizzbuzz: fizzbuzz,
        numbers: numbers
    };
}


// ============================================
// Results Display Module
// ============================================

function $705482df8f59d364$export$9aa35f3185551f42(results) {
    $705482df8f59d364$var$renderSequence(results);
    $705482df8f59d364$var$renderStats(results);
}
/**
 * Renders the color-coded badge grid.
 * @param {import('./fizzBuzz.js').FizzBuzzItem[]} results
 */ function $705482df8f59d364$var$renderSequence(results) {
    var output = document.getElementById('resultsOutput');
    if (!output) {
        console.error('resultsOutput element not found');
        return;
    }
    if (results.length === 0) {
        output.innerHTML = '<p class="text-muted">No results to display.</p>';
        return;
    }
    var fragment = document.createDocumentFragment();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = results[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var type = (0, $8adeb145de721250$export$2cf3d65bc6f74f7d)(item.label);
            var span = document.createElement('span');
            span.className = "badge result-badge ".concat(type, "-badge");
            span.setAttribute('title', "".concat(item.value, ": ").concat(item.label));
            span.textContent = item.label;
            fragment.appendChild(span);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    output.textContent = '';
    output.appendChild(fragment);
}
/**
 * Renders the statistics bar.
 * @param {import('./fizzBuzz.js').FizzBuzzItem[]} results
 */ function $705482df8f59d364$var$renderStats(results) {
    var stats = document.getElementById('statsDisplay');
    if (!stats) return;
    if (results.length === 0) {
        stats.textContent = '';
        return;
    }
    var counts = (0, $8adeb145de721250$export$3512942180f1c205)(results);
    var total = results.length;
    stats.textContent = '';
    var items = [
        {
            label: 'Total',
            value: total,
            cls: 'text-secondary'
        },
        {
            label: 'Fizz',
            value: counts.fizz,
            cls: 'text-primary'
        },
        {
            label: 'Buzz',
            value: counts.buzz,
            cls: 'text-success'
        },
        {
            label: 'FizzBuzz',
            value: counts.fizzbuzz,
            cls: 'text-warning'
        },
        {
            label: 'Numbers',
            value: counts.numbers,
            cls: 'text-muted'
        }
    ];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var span = document.createElement('span');
            span.className = "stats-item me-3 small ".concat(item.cls);
            span.innerHTML = "<strong>".concat(item.label, ":</strong> ").concat(item.value);
            stats.appendChild(span);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}


// ── DOM references ──────────────────────────────────────────────────────────
var $8ad0536b9450bda3$var$fizzInput = document.getElementById('fizzInput');
var $8ad0536b9450bda3$var$buzzInput = document.getElementById('buzzInput');
var $8ad0536b9450bda3$var$limitInput = document.getElementById('limitInput');
var $8ad0536b9450bda3$var$generateBtn = document.getElementById('generateBtn');
var $8ad0536b9450bda3$var$resetBtn = document.getElementById('resetBtn');
var $8ad0536b9450bda3$var$DEFAULTS = {
    fizz: 3,
    buzz: 5,
    limit: 100
};
// ── Init ─────────────────────────────────────────────────────────────────────
(0, $8Y07q.initThemeToggle)();
// ── Actions ───────────────────────────────────────────────────────────────────
function $8ad0536b9450bda3$var$generate() {
    var fizz = parseInt($8ad0536b9450bda3$var$fizzInput.value, 10);
    var buzz = parseInt($8ad0536b9450bda3$var$buzzInput.value, 10);
    var limit = parseInt($8ad0536b9450bda3$var$limitInput.value, 10);
    var validation = (0, $8adeb145de721250$export$b8d6bda6b8a0445d)(fizz, buzz, limit);
    if (!validation.valid) {
        (0, $b4vhW.showError)(validation.error);
        return;
    }
    var results = (0, $8adeb145de721250$export$ee099e9526bafddb)(fizz, buzz, limit);
    (0, $705482df8f59d364$export$9aa35f3185551f42)(results);
    (0, $b4vhW.showSuccess)("Generated FizzBuzz from 1 to ".concat(limit, " (Fizz=").concat(fizz, ", Buzz=").concat(buzz, ")."));
}
function $8ad0536b9450bda3$var$resetDefaults() {
    $8ad0536b9450bda3$var$fizzInput.value = $8ad0536b9450bda3$var$DEFAULTS.fizz;
    $8ad0536b9450bda3$var$buzzInput.value = $8ad0536b9450bda3$var$DEFAULTS.buzz;
    $8ad0536b9450bda3$var$limitInput.value = $8ad0536b9450bda3$var$DEFAULTS.limit;
    $8ad0536b9450bda3$var$generate();
}
// ── Event listeners ───────────────────────────────────────────────────────────
$8ad0536b9450bda3$var$generateBtn.addEventListener('click', $8ad0536b9450bda3$var$generate);
$8ad0536b9450bda3$var$resetBtn.addEventListener('click', $8ad0536b9450bda3$var$resetDefaults);
[
    $8ad0536b9450bda3$var$fizzInput,
    $8ad0536b9450bda3$var$buzzInput,
    $8ad0536b9450bda3$var$limitInput
].forEach(function(input) {
    input.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') $8ad0536b9450bda3$var$generate();
    });
});
// ── Auto-generate on load ─────────────────────────────────────────────────────
$8ad0536b9450bda3$var$generate();
console.log('FizzBuzz solve page initialized');

})();
//# sourceMappingURL=solve.9a4ad5e8.js.map
